// Dependencias
import { Api } from 'datatables.net-bs5';
import { StatusUsers } from '../service/client.service';
import { KiuberRoles } from '../service/kiuber.service';

/**
 *
 * @param options
 */
export function drawTable<T extends Array<any>>({
  data,
  table,
  format,
  addFinale = false
}: OptionsToDraw<T>) {
  // Asigno el formateador definido por el cliente o lo combierto a un array de arrays
  const values = format ? format(data) : data.map((row) => Object.values(row));

  // Establezco los datos en la tabla y los pinto en pantalla
  if (!addFinale) table.clear().page(1);
  for (const row of values) table.row.add(row);
  table.draw(false);
}

/**
 *
 * @param phone
 * @returns
 */
export function formatPhoneNumber(phone: string | null) {
  // Valido que exista un numero de telefono
  if (!phone) return 'N/A';

  const [contryCode, number] = phone.includes(' ')
    ? phone.split(' ')
    : [null, phone];

  const bigLadas = ['55', '56', '33', '81'];
  let formatNumber: string[] = [];

  // Verifico si el numero corresponde a alguna lada
  const someStartWiththisLada = bigLadas.some((lada) =>
    number.startsWith(lada)
  );
  if (someStartWiththisLada) {
    const part1 = number.substring(0, 2);
    const part2 = number.substring(2, 6);
    const part3 = number.substring(6);

    formatNumber = [part1, part2, part3];
  } else {
    const part1 = number.substring(0, 3);
    const part2 = number.substring(3, 6);
    const part3 = number.substring(6, 10);

    formatNumber = [part1, part2, part3];
  }

  return contryCode
    ? `+${contryCode} ${formatNumber.join('-')}`
    : formatNumber.join('-');
}

/**
 *
 * @param type
 * @returns
 */
export function drawPlanElement(type: Plans) {
  return type === Plans.LITE
    ? `
        <span class="badge rounded-pill bg-secondary fs-6">
          Lite <i class="bi bi-person-fill"></i>
        </span>
      `
    : `
      <span class="badge rounded-pill bg-primary fs-6">
        Advance <i class="bi bi-cash-stack"></i>
      </span>
    `;
}

/**
 *
 * @param isVerify
 * @returns
 */
export function drawStatusElement(isVerify: StatusUsers) {
  return isVerify === StatusUsers.VERIFICADO
    ? `
      <span class="badge rounded-pill bg-success fs-6">
        Verificado <i class="bi bi-person-fill-check"></i>
      </span>
    `
    : `
      <span class="badge rounded-pill bg-danger fs-6">
        Rechazado <i class="bi bi-person-fill-x"></i>
      </span>
    `;
}

/**
 *
 * @param yes
 * @returns
 */
export function drawYesNoElement(yes: boolean) {
  return yes
    ? `
      <span class="badge rounded-pill bg-success fs-6">
        Si <i class="bi bi-check-circle-fill"></i>
      </span>
    `
    : `
      <span class="badge rounded-pill bg-black fs-6">
        No <i class="bi bi-x-circle-fill"></i>
      </span>
    `;
}

/**
 *
 * @param id
 * @returns
 */
export function drawAcctionButonElement(id: number) {
  return `
    <a href="/users/check/${id}" class="btn btn-light btn-loader">
      Ver <i class="bi bi-eye"></i>
    </a>
  `;
}

/**
 *
 * @param reason
 * @returns
 */
export function drawShowMoreButton(reason: string) {
  return `
    <button type="button" class="btn btn-info"
      data-bs-toggle="modal" data-bs-target="#rejectionReasonModal"
      data-rejection-reason="${reason}">
      Ver motivo
    </button>
  `;
}

/**
 *
 * @param id
 * @returns
 */
export function drawShowAsingFolio(idClient: number, id: number) {
  return ` 
    <button class="btn btn-info" data-id-client="${idClient}" data-id="${id}">
      <i class="bi bi-file-earmark-plus"></i> Asignar
    </button>
  `;
}

// Elementos para Kiubers

/**
 *
 * @param idKiuber
 * @returns
 */
export function drawEditButomKiuber(idKiuber: number) {
  return `
    <button type="button" class="btn btn-light" data-id="${idKiuber}">
      <i class="bi bi-pencil-fill"></i> Editar
    </button>
  `;
}

/**
 *
 * @param role
 * @returns
 */
export function drawRoleKiuber(role: KiuberRoles) {
  if (role === KiuberRoles.ADMIN) 
    return `
      <span class="fs-6 badge bg-info"><i class="bi bi-person-fill-gear"></i> Administrador</span>
    `;
  else if(role === KiuberRoles.SQUAD)
    return `
      <span class="fs-6 badge bg-primary"><i class="bi bi-people-fill"></i> Soporte</span>
    `;
  else if (role === KiuberRoles.SALES)
    return `
      <span class="fs-6 badge bg-warning"><i class="bi bi-person-workspace"></i> Ventas</span>
    `;
  else
    return `
      <span class="fs-6 badge bg-dark"><i class="bi bi-person-fill"></i> N/A</span>
    `;
}

/**
 * 
 * @param active 
 * @returns 
 */
export function drawActiveKiuber(active: number) {
  if (active)
    return `
      <span class="fs-6 badge bg-success">
        <i class="bi bi-check-circle"></i> Activo
      </span>
    `;
  else
    return `
      <span class="fs-6 badge bg-danger">
        <i class="bi bi-exclamation-circle"></i> Inactivo
      </span>
    `;
}

/**
 * Dibuja un switch para activar/desactivar el campo API de un usuario
 * @param userId ID del usuario
 * @param apiEnabled Estado actual del campo API (true/false)
 * @returns 
 */
export function drawApiToggle(userId: number, apiEnabled: boolean) {
  return `
    <div class="form-check form-switch d-flex justify-content-center">
      <input
        class="form-check-input api-toggle"
        type="checkbox"
        role="switch"
        data-user-id="${userId}"
        ${apiEnabled ? 'checked' : ''}
        style="cursor: pointer; width: 3rem; height: 1.5rem;"
      >
    </div>
  `;
}

/**
 * Dibuja un switch para bloquear/desbloquear a un usuario
 * @param userId ID del usuario
 * @param blocked Estado actual de bloqueo (true/false)
 * @returns
 */
export function drawBlockToggle(userId: number, blocked: boolean) {
  return `
    <div class="form-check form-switch d-flex justify-content-center">
      <input
        class="form-check-input block-toggle"
        type="checkbox"
        role="switch"
        data-user-id="${userId}"
        ${blocked ? 'checked' : ''}
        style="cursor: pointer; width: 3rem; height: 1.5rem;"
      >
    </div>
  `;
}

// Tipos e Interfaces
export type OptionsToDraw<T extends Array<any>> = {
  data: T;
  table: Api<string[]>;
  format: (data: T) => (string | number)[][];
  addFinale?: boolean;
};
export enum Plans {
  LITE = 'lite',
  ADVANCE = 'advance',
}
